/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Lifecycle states for courses
 */
export type CourseLifecycleState = (typeof CourseLifecycleState)[keyof typeof CourseLifecycleState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseLifecycleState = {
  active: 'active',
  stale: 'stale',
  retired: 'retired',
} as const;
